import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/WarningLogReport/WarningLogReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class WarningLogReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/WarningLogReport/WarningLogReport")
	}

	render() {
		return (
			<Activity 
				name="WarningLog"
				RenderedComponent={this.RenderedComponent}
				context="WarningLog"
				action="WarningLogReport"
				formActions={FormAction}    
            />
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(WarningLogReportActivity)